import { combineReducers } from "redux";
import { createDataReducer } from "../../store/dataReducer";
import { createRequestReducer } from "../../store/requestReducer";
import * as actions from "./firmsActions";

export const initialState = {
  totalFirms: 0,
  pageDetails: {
    page: 0,
    rowsPerPage: 10,
    sortColumn: 'ExternalCompanyId',
    sortDirection: 'desc',
    filterObject: {
      FirmName: '',
    },
    currentSortedColumnName: 'Firm ID',
  },
};

export function pageDetailsReducer(state = initialState.pageDetails, action = {}) {
  if (action.type === actions.SET_PAGE_DETAILS) {
    return action.pageDetails;
  }

  return state;
}

export function totalFirmsReducer(
  state = initialState.totalFirms,
  action = {},
) {
  if (action.type === actions.SET_TOTAL_FIRMS) {
    return action.totalFirms;
  }

  return state;
}

export function editFirmDataReducer(state = null, action = {}) {
  if (action.type === actions.SET_EDIT_FIRM_DATA) {
    return action.editFirmData;
  }

  if (action.type === actions.CLEAR_EDIT_FIRM_DATA) {
    return null;
  }

  return state;
}

export default combineReducers({
  data: createDataReducer({ SET_DATA: actions.SET_DATA }),
  totalFirms: totalFirmsReducer,
  firmsPageDetails: pageDetailsReducer,
  editFirmData: editFirmDataReducer,
  request: createRequestReducer({
    ERROR: actions.ERROR,
    LOADING: actions.LOADING,
  }),
});
